import { Reference } from '@/types';
import { getParams } from '@/utils/params';
import { mapDraftToSharingDraft } from '@/model/draftMapper/mapDraftToSharingDraft';
import { getDraft } from '@/redux/draft/getters/getDraft';
import { StoreState } from '@/redux/types';
import { getMementoKey } from './getMementoKey';
import { isMementoEnabled } from './status';

export const writeToMemento = (state: StoreState, productReference?: Reference) => {
  if (!isMementoEnabled()) {
    return;
  }

  try {
    const draft = mapDraftToSharingDraft(getDraft(state));
    const json = JSON.stringify({ ...draft, product: productReference });
    const { contextId, platform } = getParams();
    window.localStorage.setItem(getMementoKey(contextId, platform), json);
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.error(e);
    }
  }
};
